import React from 'react';
import { faLayerGroup } from '@fortawesome/free-solid-svg-icons';
import { WidgetRow, WidgetFooter, WidgetEmpty, Pill, Age, useGoTo } from './common';

const STATUS_TONE = {
  Draft: 'neutral',
  Generated: 'info',
  Saved: 'info',
  Partial: 'pending',
  'Fully Allocated': 'ok',
  Dormant: 'neutral',
};

const MyDealsWidget = ({ data }) => {
  const goTo = useGoTo();
  const items = data.items || [];
  const groups = data.groups || [];
  return (
    <>
      {groups.length > 0 && (
        <div className="mydesk-groups">
          {groups.map((g) => (
            <span key={g.status} className="mydesk-group">
              <strong>{g.count}</strong> {g.label}
            </span>
          ))}
        </div>
      )}
      {items.length === 0 && <WidgetEmpty>You have no open deals.</WidgetEmpty>}
      {items.map((d) => (
        <WidgetRow
          key={d.id}
          icon={faLayerGroup}
          tone="brand"
          title={d.partner_name || d.number}
          subtitle={[d.number, d.commodity_label, d.recap_count ? `${d.recap_count} recap${d.recap_count === 1 ? '' : 's'}` : ''].filter(Boolean).join(' · ')}
          right={(
            <>
              <Pill tone={STATUS_TONE[d.status] || 'neutral'}>{d.status_label || d.status}</Pill>
              <Age>{d.age_label}</Age>
            </>
          )}
          onClick={d.url ? () => goTo(d.url) : undefined}
        />
      ))}
      <WidgetFooter label="Open Trade Operations" url={data.url} />
    </>
  );
};

export default MyDealsWidget;
